import { render, staticRenderFns } from "./OrdemServicoForm2.vue?vue&type=template&id=60e3ceaa&scoped=true&"
import script from "./OrdemServicoForm2.vue?vue&type=script&lang=js&"
export * from "./OrdemServicoForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3ceaa",
  null
  
)

export default component.exports